export default "__VITE_ASSET__5eff349a__"